import Toast from '@/components/elements/toast'
import { useEffect } from 'react'
import { FieldErrors } from 'react-hook-form'


export const useFormErrorToast = (errors: FieldErrors<any>) => {
    useEffect(() => {
        const getFirstError = (errorsObj: any): string | null => {
            for (const key in errorsObj) {
                const error = errorsObj[key]

                if (error?.message) {
                    return error.message
                }

                if (error && typeof error === 'object') {
                    const nestedError = getFirstError(error)
                    if (nestedError) return nestedError
                }
            }
            return null
        }

        const firstErrorMessage = getFirstError(errors)

        if (firstErrorMessage) {
            Toast({
                type: 'error',
                duration: 3000,
                message: firstErrorMessage,
            })
        }
    }, [errors])
}